import { kebabCase } from 'lodash';

import '@splidejs/splide/css/core';

import './theme/tokens.scss';
import './theme/breakpoints.scss'
import './theme/gradients.scss';
import './theme/typography.scss';
import './theme/global.scss';
import './overrides/typography.scss';
import './overrides/btn.scss';
import './overrides/pagination.scss';
import './overrides/input.scss'
import './overrides/facets.scss';
import './overrides/questions.scss';
import './overrides/forms.scss';
import './overrides/search.scss';
import './overrides/tabs.scss';
import './overrides/option-inputs.scss';
import './overrides/membershipSideBarMenu.scss';
import './overrides/misc-styles.scss';
import './sections/footer.scss';

import './components/chroa-card';
import './components/chroa-meta-tag';

import './fragments/basics/chroa-border-line';
import './fragments/basics/chroa-button';
import './fragments/basics/chroa-button-pub-priv';
import './fragments/basics/chroa-heading';
import './fragments/basics/chroa-large-text';
import './fragments/cards/chroa-article-card-list';
import './fragments/cards/chroa-article-pdf-card-solo';
import './fragments/cards/chroa-card-event';
import './fragments/cards/chroa-card-featured';
import './fragments/cards/chroa-card-header';
import './fragments/cards/chroa-card-resource';
import './fragments/cards/chroa-card-resource-podcast';
import './fragments/cards/chroa-membership-card';
import './fragments/cards/chroa-membership-cards-list';
import './fragments/cards/chroa-person-card-list';
import './fragments/cards/chroa-profile-card';
import './fragments/cards/chroa-quote-card';
import './fragments/cards/chroa-recent-discussion-card';
import './fragments/cards/chroa-person-card';
import './fragments/cards/chroa-registration-card';
import './fragments/content/chroa-article-banner';
import './fragments/content/chroa-banner';
import './fragments/content/chroa-betty-bot';
import './fragments/content/chroa-betty-bot-widget';
import './fragments/content/chroa-bio-banner';
import './fragments/content/chroa-bio-body';
import './fragments/content/chroa-chip';
import './fragments/content/chroa-chip-set';
import './fragments/content/chroa-contact-button';
import './fragments/content/chroa-content-gate';
import './fragments/content/chroa-contributor-block';
import './fragments/content/chroa-event-section';
import './fragments/content/chroa-event-session';
import './fragments/content/chroa-eyebrow-nav';
import './fragments/content/chroa-faq-item';
import './fragments/content/chroa-faq-wrap';
import './fragments/content/chroa-full-page-hero';
import './fragments/content/chroa-50-50-hero';
import './fragments/content/chroa-list-header';
import './fragments/content/chroa-member-dashboard-banner';
import './fragments/content/chroa-members-box-multi-link-cta';
import './fragments/content/chroa-members-network';
import './fragments/content/chroa-on-this-page';
import './fragments/content/chroa-page-banner';
import './fragments/content/chroa-person-modal';
import './fragments/content/chroa-person-modal-prompt';
import './fragments/content/chroa-podcast-banner';
import './fragments/content/chroa-poster-banner';
import './fragments/content/chroa-related-people';
import './fragments/content/chroa-resource-body';
import './fragments/content/chroa-resource-body-minimal';
import './fragments/content/chroa-related-block';
import './fragments/content/chroa-podcast-body';
import './fragments/content/chroa-search-block';
import './fragments/content/chroa-social-sharing';
import './fragments/content/chroa-sub-nav-bar';
import './fragments/content/chroa-testimonial-block';
import './fragments/content/chroa-timeline-block';
import './fragments/content/chroa-timeline-slide';
import './fragments/content/chroa-event-banner';
import './fragments/content/chroa-event-microsite-banner';
import './fragments/content/chroa-event-body';
import './fragments/content/chroa-event-people';
import './fragments/content/chroa-event-supplemental-info';
import './fragments/content/chroa-video-slider';
import './fragments/content/chroa-video-slide';
import './fragments/layouts/chroa-2-col-flexible';
import './fragments/layouts/chroa-2-col-row';
import './fragments/layouts/chroa-2-col-row-wide-left';
import './fragments/layouts/chroa-3-col-row';
import './fragments/layouts/chroa-4-col-row';
import './fragments/layouts/chroa-article-content';
import './fragments/layouts/chroa-content-backsplash';
import './fragments/layouts/chroa-content-wrap';
import './fragments/layouts/chroa-featured-resources';
import './fragments/layouts/chroa-flex-content';
import './fragments/layouts/chroa-page-content';
import './fragments/layouts/chroa-search-layout';
import './fragments/layouts/chroa-section';
import './fragments/layouts/chroa-spacer';
import './fragments/layouts/chroa-sticky-zone';
import './fragments/shell/chroa-site-footer';
import './fragments/shell/chroa-site-header';
import './fragments/util/npt-collection-config';
import './fragments/util/npt-conditional-content';
import './fragments/util/npt-segmented-content';


import './widgets/chroa-category-list-facet';
import './widgets/chroa-category-tree-facet';
import './widgets/chroa-discussion-board';
import './widgets/chroa-search-results';
import {selectAll} from '@neptune/cx/utils';

(() => {
    const targetSel = 'a[href*="/login-portlet/-/login/openid_connect_request"]';
    const redirectParam = '_com_liferay_login_web_portlet_LoginPortlet_redirect';

    const cur = new URL(location.href);
    let redirect = cur.pathname + cur.search + cur.hash;

    if (cur.search.includes('com_liferay_login_web_portlet_LoginPortlet')) {
        const raw = cur.searchParams.get(redirectParam);
        if (raw) {
            let r = raw;
            try { r = decodeURIComponent(r); } catch {}
            try {
                const u = new URL(r, location.origin);
                if (u.origin === location.origin) {
                    // A fragment never reaches the server, so the server's redirect can never
                    // carry one -- but the browser re-applies the fragment of the page the
                    // visitor was bounced off onto each redirect hop, so it is still in the
                    // address bar here and belongs on the way back. Legacy discussion links
                    // (#/questions/...) are the reason this matters.
                    if (!u.hash && cur.hash) u.hash = cur.hash;

                    redirect = u.pathname + u.search + u.hash;
                }
            } catch {}
        }
    }

    selectAll<HTMLAnchorElement>(targetSel).forEach(a => {
        a.dataset.sennaOff = 'true';
        const u = new URL(a.getAttribute('href') || '', location.origin);
        u.searchParams.set(redirectParam, redirect);
        ['p_p_state','p_p_mode','_com_liferay_login_web_portlet_LoginPortlet_mvcRenderCommandName','saveLastPath']
            .forEach(k => u.searchParams.delete(k));
        a.href = u.toString();
    });
})();


if (import.meta.hot) {
    import.meta.hot.accept();
}





























